import { create } from "zustand";
import { medicines, deleteMedicines, addMedicines } from "../api_layer/api";

export const useMedicinesStore = create((set) => ({
    medicinesData: [],
    medicinesLoading: false,
    addLoading: false,
    deleteLoading:false,
    error: null,
    fetchMedicinesData: async (query) => {
      try {
        set({ medicinesLoading: true, error: null });
        const response = await medicines(query);
        set({ medicinesData: response.data, medicinesLoading: false });
      } catch (error) {
        set({ error: error.message, medicinesLoading: false });
      }
    },
    addMedicinesData: async (payload, setToaster,fetchMedicinesData, handleModalClose) => {
      try {
        set({ addLoading: true, error: null });
        const response = await addMedicines(payload);
        setToaster("Medicines", "Medicines added successfully", "success");
        fetchMedicinesData();
        handleModalClose();
        set({ addLoading: false });
      } catch (error) {
        handleModalClose();
        setToaster("Medicines", "Adding medicines failed", "danger");
        set({ error: error.message, addLoading: false });
      }
    },
    deleteMedicinesData: async (id, setToaster,fetchMedicinesData) => {
        try {
          set({ deleteLoading: true, error: null });
          const response = await deleteMedicines(id);
          setToaster("Medicines", "Medicines deleted successfully", "success");
          fetchMedicinesData();
          set({ deleteLoading: false });
        } catch (error) {
          setToaster("Medicines", "Failed to delete medicines", "danger");
          set({ error: error.message, deleteLoading: false });
        }
      },
  }));
  